var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showId && _vm.territory && _vm.intro)?_c('div',{staticClass:"map-intro-card"},[_c('div',{staticClass:"eq-title"},[_vm._v(_vm._s(_vm.territory))]),_c('div',{staticClass:"intro",domProps:{"innerHTML":_vm._s(_vm.intro)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }